export default __webpack_public_path__ + "static/media/2216.6db114de.png";